import React, {Component} from 'react';
import Parallax from 'parallax-js/dist/parallax';
import {Link, withRouter} from 'react-router-dom';

import _ from 'lodash';
import moment from 'moment';
import Introduction from '../components/Introduction';
import TipsVideo from '../components/TipsVideo';
import MeetTheTeam from '../components/MeetTheTeam';
import SampleTutorials from '../components/SampleTutorials';
import WhoAreWe from '../components/WhoAreWe';
import Tutorials from '../components/Tutorials';
import Testimonials from '../components/Testimonials';
import Scroll from 'react-scroll/modules';
// import { inject, observer } from 'mobx-react';
import HttpClient from 'services/HttpClient';
import {containers as BaseContainers} from '../../../modules/core';
import landingHeroImg from 'images/landing-girl.png';
import {medSvg} from 'constants/svg';
import {booksSvg} from 'constants/svg';
import {videoSvg} from 'constants/svg';
import {Background} from '../components/Background';

let scroll = Scroll.animateScroll;

const {Footer} = BaseContainers;

@withRouter
export default class extends Component {
  state = {
    courses: [],
  }

  componentDidMount() {
    const scene = document.getElementById('scene');
    new Parallax(scene);
    this.listener = this.props.history.listen(location => {
      this.initScroll(location)
    });
  }

  initScroll(location){
    if(location.pathname === '/pricing') {
      scroll.scrollTo(3075, {isDynamic: true});
    }
    else {
      scroll.scrollToTop();
    }
  }

  componentWillUnmount(){
    this.listener();
  }

  render() {
    return (
      <div
        className="landing">
        <section
          className="section player">
          <Background />
          {/* <div
            className="player-play-wrapper">
            <div
              className="player-caption">
              <h1>
                Tips and tricks</h1>
              <p>
                ON HOW TO PREPARE FOR THE MIGCP EXAM
              </p>
            </div>

            <div
              className="player-signup" style={{marginTop: 0}}>
              <Link to="/signUp"
                 className="btn signup rounded">SIGN
                UP</Link>
              <p className="signup-label">
                {'> 50 TOPICS FEATURED IN MICGP EXAM'}
              </p>
              <p className="signup-label">
                {'COST: € 595 PER YEAR (Fully reimbursable under the NCHD TSS)'}
              </p>
            </div>

            <div
              className="player-signup sign-in" style={{marginTop: 15}}>
              <p className="signin-label">Already have an account?</p>
              <Link to="/signIn"
                    className="btn signup rounded signin">LOG IN</Link>
            </div> */}
            {/* <div
              className="player-play">
              <img src={landingHeroImg} alt="Landing hero image" className='landing-hero-img' />
            </div> */}
          {/* </div> */}


          <div className="player-play-wrapper">
            <div className="player-caption">
              <h1 className='section-title'>Exam Prep Courses for Irish GP Trainees</h1>
            </div>

            <div className='row align-items-start justify-content-between'>
              <div className='column max-w-400 landing-option'>
                <div className="player-signup">
                  <p className='signup-label landing-option-title'>MICGP CKT EXAM PREP</p>
                  <ul className='landing-options-list'>
                    <li>
                      <p className="landing-option-text">
                        {'20 high yield topics for the CKT'}
                      </p>
                    </li>
                    <li>
                      <p className="landing-option-text">
                        {'Videos on question prep including key domains to cover'}
                      </p>
                    </li>
                    <li>
                      <p className="landing-option-text">
                        {'Exam technique tips: reading CKT questions, keywords to watch out for, question formats, time management, common mistakes to avoid'}
                      </p>
                    </li>
                    <li>
                      <p className="landing-option-text">
                        {'ANNUAL SUBSCRIPTION - € 595'}
                      </p>
                    </li>
                    <li>
                      <p className="landing-option-text">
                        {'6 MONTH SUBSCRIPTION - € 445'}
                      </p>
                    </li>
                    <li>
                      <p className="landing-option-text">
                        {'3 MONTH SUBSCRIPTION - € 275'}
                      </p>
                    </li>
                  </ul>
                </div>
                <Link to="/signUp" className="btn signup rounded">SIGN UP</Link>
              </div>

              <div className='column max-w-400 landing-option'>
                <div className="player-signup">
                  <p className='signup-label landing-option-title'>MICGP CCT EXAM PREP</p>
                  <ul className='landing-options-list'>
                    <li>
                      <p className="landing-option-text">
                        {'17 sample CCT practice cases'}
                      </p>
                    </li>
                    <li>
                      <p className="landing-option-text">
                        {'60 common CCT cases discussed in detail'}
                      </p>
                    </li>
                    <li>
                      <p className="landing-option-text">
                        {'Current CCT marking format adhered to'}
                      </p>
                    </li>
                    <li>
                      <p className="landing-option-text">
                        {'Tips on how to prepare: how to hit the criteria, common reasons for failing a case'}
                      </p>
                    </li>
                    <li>
                      <p className="landing-option-text">
                        {'ANNUAL SUBSCRIPTION - € 795'}
                      </p>
                    </li>
                    <li>
                      <p className="landing-option-text">
                        {'6 MONTH SUBSCRIPTION - € 645'}
                      </p>
                    </li>
                    <li>
                      <p className="landing-option-text">
                        {'3 MONTH SUBSCRIPTION - € 475'}
                      </p>
                    </li>
                  </ul>
                </div>
                <Link to="/signUp" className="btn signup rounded">SIGN UP</Link>
              </div>
            </div>
            <div className="player-signup" style={{margin: '16px'}}>
              <p className='signup-label landing-option-title' style={{fontSize: '14px', textTransform: 'unset'}}>MICGP CKT EXAM PREP and CCT EXAM PREP modules are fully reimbursable under the training support scheme (TSS)</p>
              <p className='signup-label landing-option-title' style={{fontSize: '14px', textTransform: 'unset'}}>PLUS podcasts and videos on &gt; 50 topics covering conditions seen in everyday practice</p>
            </div>
          </div>

          {/* <div className="container-fluid flayer">
            <div className="row justify-content-center"> */}

              {/* <div className="col-md-4">
                <div className="flayer-item"> */}
                  {/* <div className="flayer-icon-wrap">{videoSvg}</div> */}
                  {/* <div className="flayer-title">Evidence Based Medicine</div>
                  <div className="flayer-desc">
                    <div>Symptoms, diagnosis and treatment of clinical conditions - all evidence based
                    </div>
                  </div>
                </div>
              </div> */}

              {/* <div className="col-md-4">
                <div className="flayer-item">
                  <div className="flayer-icon-wrap">{medSvg}</div>
                  <div className="flayer-title">Concise</div>
                  <div className="flayer-desc">
                    <div>Straight to the point
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="flayer-item">
                  <div className="flayer-icon-wrap">{booksSvg}</div>
                  <div className="flayer-title">CPD Accredited</div>
                  <div className="flayer-desc">
                    <div>Accredited for 20 External CPD Points
                    </div>
                  </div>
                </div>
              </div> */}
            {/* </div>
          </div> */}
        </section>
        <Introduction />
        <TipsVideo />
        <MeetTheTeam />
        <SampleTutorials/>
        <WhoAreWe/>
        <Testimonials/>
        {/* <Tutorials scroll={() => this.initScroll(this.props.location)}/> */}
        <Footer/>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/modules/landing/containers/Landing.js